import React, {useState, useContext, useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import {MyContext} from "../context/MyContext";


const menuInnerStyle = { overflowY: 'auto', maxHeight: 'calc(100vh - 64px)' };

function Menu() {

  const initialized = useRef(false)
  const [active, setActive] = useState('HOME');
  const [open, setOpen] = useState(false);
  const [subactive, setSubActive] = useState(null);
  const [selected, setSelected] = useState(null);
  const { toggleMenu, setToggleMenu } = useContext(MyContext);
  const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));

  useEffect(() => {
    if (!initialized.current) {
        initialized.current = true
        let menuOption = sessionStorage.getItem('menuOption');
        let submenuOption = sessionStorage.getItem('submenuOption');
        if(menuOption !==''){ setMenu(menuOption) }
        if(submenuOption !==''){ setSubmenu(menuOption, submenuOption) }
    }
  }, []);

  function setMenu (option)  {
    setOpen(!open); 
    setSelected(option);
    sessionStorage.setItem('menuOption', option );

  }

  function setSubmenu (parent, child)  {
    setSubActive(child)
    setActive(parent)
    setSelected(parent)
    setOpen(true)
    sessionStorage.setItem('menuOption', parent );
    sessionStorage.setItem('submenuOption', child );
  }

  // SUPER ADMIN
  if(userProfile.roleid === 1){
    return (
      <>
        {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                    <li id="DDJJ-DOCUMENTS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-DOCUMENTS')}
                      className={`menu-item ${subactive === 'DDJJ-DOCUMENTS' && "active"}`}
                    >
                      <Link to="/documents" className="menu-link ">
                        <div data-i18n="Without menu ">Documentos</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* MESA */}
                <li id="MESA"
                  onClick={() =>  { setMenu('MESA') } }
                  className={`menu-item ${active === 'MESA' && " active open"} ${(selected === 'MESA') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-bank" />
                    <div data-i18n="Layouts">Mesa</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="MESA-DASHBOARD"
                      onClick={() => setSubmenu('MESA','MESA-DASHBOARD')}
                      className={`menu-item ${subactive === 'MESA-DASHBOARD' && "active"}`}
                    >
                      <Link to="/mesaDashboard" className="menu-link ">
                        <div data-i18n="Without menu ">Dashboard</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-DIA-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-DIA-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaDayOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones del Día</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-ESCO-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-ESCO-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaEscoOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones ESCO</div>
                      </Link>
                    </li>
                    <li id="MESA-DASHBOARD-REPORT"
                      onClick={() => setSubmenu('MESA','MESA-DASHBOARD-REPORT')}
                      className={`menu-item ${subactive === 'MESA-DASHBOARD-REPORT' && "active"}`}
                    >
                      <Link to="/mesaDashboardReport" className="menu-link ">
                        <div data-i18n="Without menu ">Dashboard Reporte</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="OPERATIONS"
                  onClick={() =>  { setMenu('OPERATIONS') } }
                  className={`menu-item ${active === 'OPERATIONS' && " active open"} ${(selected === 'OPERATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">Operaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('OPERATIONS','OPERATIONS-DOLLAR')}
                      className={`menu-item ${subactive === 'OPERATIONS-DOLLAR' && "active"}`}
                    >
                      <Link to="/operations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="REPORTS"
                  onClick={() =>  { setMenu('REPORTS') } }
                  className={`menu-item ${active === 'REPORTS' && " active open"} ${(selected === 'REPORTS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-report" />
                    <div data-i18n="Layouts">Reportes</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="REPORTS-BONOS"
                      onClick={() => setSubmenu('REPORTS','REPORTS-BONOS')}
                      className={`menu-item ${subactive === 'REPORTS-BONOS' && "active"}`}
                    >
                      <Link to="/reportOperation" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                    <li id="REPORTS-MIDDLE"
                      onClick={() => setSubmenu('REPORTS','REPORTS-MIDDLE')}
                      className={`menu-item ${subactive === 'REPORTS-MIDDLE' && "active"}`}
                    >
                      <Link to="/reportOperationMiddle" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones Mesa</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* AUTHORIZATIONS */}
                <li id="AUTHORIZATIONS"
                  onClick={() =>  { setMenu('AUTHORIZATIONS') } }
                  className={`menu-item ${active === 'AUTHORIZATIONS' && " active open"} ${(selected === 'AUTHORIZATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-pen" /> 
                    <div data-i18n="Layouts">Autorizaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('AUTHORIZATIONS','AUTHORIZATIONS-REPORT')}
                      className={`menu-item ${subactive === 'AUTHORIZATIONS-REPORT' && "active"}`}
                    >
                      <Link to="/authorizations" className="menu-link ">
                        <div data-i18n="Without menu ">Autorizaciones </div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* SETTINGS */}
                <li id="SETTINGS"
                  onClick={() =>  { setMenu('SETTINGS') } }
                  className={`menu-item ${active === 'SETTINGS' && " active open"} ${(selected === 'SETTINGS') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon tf-icons bx bx-cog" /> 
                    <div data-i18n="Layouts">Configuración</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="SETTINGS-ACCOUNTS"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-ACCOUNTS')}
                      className={`menu-item ${subactive === 'SETTINGS-ACCOUNTS' && "active"}`}
                    >
                      <Link to="/accounts" className="menu-link ">
                        <div data-i18n="Without menu ">Comitentes</div>
                      </Link>
                    </li>
                    <li id="SETTINGS-TICKERS"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-TICKERS')}
                      className={`menu-item ${subactive === 'SETTINGS-TICKERS' && "active"}`}
                    >
                      <Link to="/tickers" className="menu-link ">
                        <div data-i18n="Without menu ">Especies</div>
                      </Link>
                    </li>
                    <li id="SETTINGS-FCI"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-FCI')}
                      className={`menu-item ${subactive === 'SETTINGS-FCI' && "active"}`}
                    >
                      <Link to="/funds" className="menu-link ">
                        <div data-i18n="Without menu ">Fondos Comunes Inversión</div>
                      </Link>
                    </li>
                    <li id="SETTINGS-SENDAUTH"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-SENDAUTH')}
                      className={`menu-item ${subactive === 'SETTINGS-SENDAUTH' && "active"}`}
                    >
                      <Link to="/sendauth" className="menu-link ">
                        <div data-i18n="Without menu ">Envio Autorizaciones</div>
                      </Link>
                    </li>
                    <li id="SETTINGS-PORTFOLIO"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-PORTFOLIO')}
                      className={`menu-item ${subactive === 'SETTINGS-PORTFOLIO' && "active"}`}
                    >
                      <Link to="/portfolioManagers" className="menu-link ">
                        <div data-i18n="Without menu ">Comerciales</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                  {/* USERS */}
                  <li id="USERS" 
                  onClick={() => setSubmenu('USERS','USERS-USERS')}
                  className={`menu-item ${active === 'USERS' && "active"}`}
                >
                  <Link to="/users" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-lock-open-alt" />
                    <div data-i18n="Authentications">Usuario</div>
                  </Link>
                </li>
              </ul>
          </aside>
        } 
      </>
    );
  }

  // COMERCIAL
  if(userProfile.roleid === 2){
    return (
      <>
        {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="OPERATIONS"
                  onClick={() =>  { setMenu('OPERATIONS') } }
                  className={`menu-item ${active === 'OPERATIONS' && " active open"} ${(selected === 'OPERATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">Operaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('OPERATIONS','OPERATIONS-DOLLAR')}
                      className={`menu-item ${subactive === 'OPERATIONS-DOLLAR' && "active"}`}
                    >
                      <Link to="/operations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="REPORTS"
                  onClick={() =>  { setMenu('REPORTS') } }
                  className={`menu-item ${active === 'REPORTS' && " active open"} ${(selected === 'REPORTS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-report" />
                    <div data-i18n="Layouts">Reportes</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="REPORTS-BONOS"
                      onClick={() => setSubmenu('REPORTS','REPORTS-BONOS')}
                      className={`menu-item ${subactive === 'REPORTS-BONOS' && "active"}`}
                    >
                      <Link to="/reportOperation" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* AUTHORIZATIONS */}
                <li id="AUTHORIZATIONS"
                  onClick={() =>  { setMenu('AUTHORIZATIONS') } }
                  className={`menu-item ${active === 'AUTHORIZATIONS' && " active open"} ${(selected === 'AUTHORIZATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-pen" /> 
                    <div data-i18n="Layouts">Autorizaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('AUTHORIZATIONS','AUTHORIZATIONS-REPORT')}
                      className={`menu-item ${subactive === 'AUTHORIZATIONS-REPORT' && "active"}`}
                    >
                      <Link to="/authorizations" className="menu-link ">
                        <div data-i18n="Without menu ">Autorizaciones </div>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* SETTINGS */}
                <li id="SETTINGS"
                  onClick={() =>  { setMenu('SETTINGS') } }
                  className={`menu-item ${active === 'SETTINGS' && " active open"} ${(selected === 'SETTINGS') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon tf-icons bx bx-cog" /> 
                    <div data-i18n="Layouts">Configuración</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="SETTINGS-TICKERS"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-TICKERS')}
                      className={`menu-item ${subactive === 'SETTINGS-TICKERS' && "active"}`}
                    >
                      <Link to="/tickers" className="menu-link ">
                        <div data-i18n="Without menu ">Especies</div>
                      </Link>
                    </li>
                  </ul>
                </li>

              </ul>
              
          </aside>
        }
      </>
    )
  }

  // COMERCIAL LOW
  if(userProfile.roleid === 8){
    return (
      <>
        {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="OPERATIONS"
                  onClick={() =>  { setMenu('OPERATIONS') } }
                  className={`menu-item ${active === 'OPERATIONS' && " active open"} ${(selected === 'OPERATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">Operaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('OPERATIONS','OPERATIONS-DOLLAR')}
                      className={`menu-item ${subactive === 'OPERATIONS-DOLLAR' && "active"}`}
                    >
                      <Link to="/operations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                <li id="REPORTS"
                  onClick={() =>  { setMenu('REPORTS') } }
                  className={`menu-item ${active === 'REPORTS' && " active open"} ${(selected === 'REPORTS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-report" />
                    <div data-i18n="Layouts">Reportes</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="REPORTS-BONOS"
                      onClick={() => setSubmenu('REPORTS','REPORTS-BONOS')}
                      className={`menu-item ${subactive === 'REPORTS-BONOS' && "active"}`}
                    >
                      <Link to="/reportOperation" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* AUTHORIZATIONS */}
                <li id="AUTHORIZATIONS"
                  onClick={() =>  { setMenu('AUTHORIZATIONS') } }
                  className={`menu-item ${active === 'AUTHORIZATIONS' && " active open"} ${(selected === 'AUTHORIZATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-pen" /> 
                    <div data-i18n="Layouts">Autorizaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('AUTHORIZATIONS','AUTHORIZATIONS-REPORT')}
                      className={`menu-item ${subactive === 'AUTHORIZATIONS-REPORT' && "active"}`}
                    >
                      <Link to="/authorizations" className="menu-link ">
                        <div data-i18n="Without menu ">Autorizaciones </div>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* SETTINGS */}
                <li id="SETTINGS"
                  onClick={() =>  { setMenu('SETTINGS') } }
                  className={`menu-item ${active === 'SETTINGS' && " active open"} ${(selected === 'SETTINGS') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon tf-icons bx bx-cog" /> 
                    <div data-i18n="Layouts">Configuración</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="SETTINGS-TICKERS"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-TICKERS')}
                      className={`menu-item ${subactive === 'SETTINGS-TICKERS' && "active"}`}
                    >
                      <Link to="/tickers" className="menu-link ">
                        <div data-i18n="Without menu ">Especies</div>
                      </Link>
                    </li>
                  </ul>
                </li>

              </ul>
              
          </aside>
        }
      </>
    )
  }

  // LEGALES
  if(userProfile.roleid === 4){
    return (
      <>
        {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                    <li id="DDJJ-DOCUMENTS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-DOCUMENTS')}
                      className={`menu-item ${subactive === 'DDJJ-DOCUMENTS' && "active"}`}
                    >
                      <Link to="/documents" className="menu-link ">
                        <div data-i18n="Without menu ">Documentos</div>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
          </aside>
        }
      </>
    )
  }

  // BACKOFFICE
  if(userProfile.roleid === 5){
    return (
      <>
        {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
          </aside>
        }
      </>
    )
  }

  // TRADERS (6)
  if(userProfile.roleid === 6){
    return (
      <>
      {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* MESA */}
                <li id="MESA"
                  onClick={() =>  { setMenu('MESA') } }
                  className={`menu-item ${active === 'MESA' && " active open"} ${(selected === 'MESA') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-bank" />
                    <div data-i18n="Layouts">Mesa</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="MESA-DASHBOARD"
                      onClick={() => setSubmenu('MESA','MESA-DASHBOARD')}
                      className={`menu-item ${subactive === 'MESA-DASHBOARD' && "active"}`}
                    >
                      <Link to="/mesaDashboard" className="menu-link ">
                        <div data-i18n="Without menu ">Dashboard</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-DIA-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-DIA-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaDayOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones del Día</div>
                      </Link>
                    </li>
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-ESCO-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-ESCO-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaEscoOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones ESCO</div>
                      </Link>
                    </li>
                    <li id="MESA-DASHBOARD-REPORT"
                      onClick={() => setSubmenu('MESA','MESA-DASHBOARD-REPORT')}
                      className={`menu-item ${subactive === 'MESA-DASHBOARD-REPORT' && "active"}`}
                    >
                      <Link to="/mesaDashboardReport" className="menu-link ">
                        <div data-i18n="Without menu ">Dashboard Reporte</div>
                      </Link>
                    </li>
                  </ul>
                </li>

                <li id="OPERATIONS"
                  onClick={() =>  { setMenu('OPERATIONS') } }
                  className={`menu-item ${active === 'OPERATIONS' && " active open"} ${(selected === 'OPERATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">Operaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('OPERATIONS','OPERATIONS-DOLLAR')}
                      className={`menu-item ${subactive === 'OPERATIONS-DOLLAR' && "active"}`}
                    >
                      <Link to="/operations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* REPORTS */}
                <li id="REPORTS"
                  onClick={() =>  { setMenu('REPORTS') } }
                  className={`menu-item ${active === 'REPORTS' && " active open"} ${(selected === 'REPORTS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-report" />
                    <div data-i18n="Layouts">Reportes</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="REPORTS-BONOS"
                      onClick={() => setSubmenu('REPORTS','REPORTS-BONOS')}
                      className={`menu-item ${subactive === 'REPORTS-BONOS' && "active"}`}
                    >
                      <Link to="/reportOperation" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                    <li id="REPORTS-MIDDLE"
                      onClick={() => setSubmenu('REPORTS','REPORTS-MIDDLE')}
                      className={`menu-item ${subactive === 'REPORTS-MIDDLE' && "active"}`}
                    >
                      <Link to="/reportOperationMiddle" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones Mesa</div>
                      </Link>
                    </li>
                  </ul>
                </li>
  
                {/* AUTHORIZATIONS */}
                <li id="AUTHORIZATIONS"
                  onClick={() =>  { setMenu('AUTHORIZATIONS') } }
                  className={`menu-item ${active === 'AUTHORIZATIONS' && " active open"} ${(selected === 'AUTHORIZATIONS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-pen" /> 
                    <div data-i18n="Layouts">Autorizaciones</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="OPERATIONS-BONOS"
                      onClick={() => setSubmenu('AUTHORIZATIONS','AUTHORIZATIONS-REPORT')}
                      className={`menu-item ${subactive === 'AUTHORIZATIONS-REPORT' && "active"}`}
                    >
                      <Link to="/authorizations" className="menu-link ">
                        <div data-i18n="Without menu ">Autorizaciones </div>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* SETTINGS */}
                <li id="SETTINGS"
                  onClick={() =>  { setMenu('SETTINGS') } }
                  className={`menu-item ${active === 'SETTINGS' && " active open"} ${(selected === 'SETTINGS') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon tf-icons bx bx-cog" /> 
                    <div data-i18n="Layouts">Configuración</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="SETTINGS-TICKERS"
                      onClick={() => setSubmenu('SETTINGS','SETTINGS-TICKERS')}
                      className={`menu-item ${subactive === 'SETTINGS-TICKERS' && "active"}`}
                    >
                      <Link to="/tickers" className="menu-link ">
                        <div data-i18n="Without menu ">Especies</div>
                      </Link>
                    </li>
                  </ul>
                </li>

              </ul>
          </aside>
        }
      </>
    )
  }

  // BACKOFFICE FCI (7)
  if(userProfile.roleid === 7){
    return (
      <>
      {toggleMenu &&
          <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="menu-inner-shadow" />
              <ul className="menu-inner py-1" style={menuInnerStyle}>
  
                <li  id="HOME" 
                  onClick={() => setSubmenu('HOME','HOME-HOME') }
                  className={`menu-item ${active === 'HOME' && "active"}`}
                >
                  <Link to="/" className="menu-link">
                    <i className="menu-icon tf-icons bx bx-home-circle" />
                    <div data-i18n="Analytics">Inicio</div>
                  </Link>
                </li>
  
                <li id="DDJJ"
                  onClick={() =>  { setMenu('DDJJ') } }
                  className={`menu-item ${active === 'DDJJ' && " active open"} ${(selected === 'DDJJ') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bx-wallet" /> 
                    <div data-i18n="Layouts">DD.JJ.</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="DDJJ-NOTIFICATIONS"
                      onClick={() => setSubmenu('DDJJ','DDJJ-NOTIFICATIONS')}
                      className={`menu-item ${subactive === 'DDJJ-NOTIFICATIONS' && "active"}`}
                    >
                      <Link to="/notifications" className="menu-link ">
                        <div data-i18n="Without menu ">Notificaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* MESA */}
                <li id="MESA"
                  onClick={() =>  { setMenu('MESA') } }
                  className={`menu-item ${active === 'MESA' && " active open"} ${(selected === 'MESA') && "open"} `}
                >
                  <Link href="javascript:void(0);" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-bank" />
                    <div data-i18n="Layouts">Operaciones FCI</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="MESA-OPERACIONES"
                      onClick={() => setSubmenu('MESA','MESA-DIA-OPERACIONES')}
                      className={`menu-item ${subactive === 'MESA-DIA-OPERACIONES' && "active"}`}
                    >
                      <Link to="/mesaDayOperations" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones del Día</div>
                      </Link>
                    </li>
                  </ul>
                </li>

                <li id="REPORTS"
                  onClick={() =>  { setMenu('REPORTS') } }
                  className={`menu-item ${active === 'REPORTS' && " active open"} ${(selected === 'REPORTS') && "open"} `}
                >
                  <Link href="/" className="menu-link menu-toggle ">
                    <i className="menu-icon bx bxs-report" />
                    <div data-i18n="Layouts">Reportes</div>
                  </Link>
                  <ul className="menu-sub">
                    <li id="REPORTS-BONOS"
                      onClick={() => setSubmenu('REPORTS','REPORTS-BONOS')}
                      className={`menu-item ${subactive === 'REPORTS-BONOS' && "active"}`}
                    >
                      <Link to="/reportOperation" className="menu-link ">
                        <div data-i18n="Without menu ">Operaciones</div>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
          </aside>
        }
      </>
    )
  }
  
}

export default Menu;
  